/* Distri Select · Refonte 2026 — interactions (annonce, sticky, menu, dates, produit) */
(function(){
  var MOIS = ['janvier','fevrier','mars','avril','mai','juin','juillet','aout','septembre','octobre','novembre','decembre'];
  var MOIS_FR = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
  function frDate(d){ return (d.getDate() === 1 ? '1ᵉʳ' : d.getDate()) + ' ' + MOIS_FR[d.getMonth()]; }
  function addDays(d, n){ var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  var now = new Date();
  /* Installation : 10 à 15 jours ouvrés ≈ J+14 à J+21 calendaires */
  var INSTALL_RANGE = 'installé entre le ' + frDate(addDays(now, 14)) + ' et le ' + frDate(addDays(now, 21));
  document.querySelectorAll('[data-install-range]').forEach(function(el){ el.textContent = el.getAttribute('data-prefix') + INSTALL_RANGE; });
  var dow = now.getDay();
  var nextSun = dow === 0 ? now : addDays(now, 7 - dow);
  var weekMon = addDays(nextSun, 15);
  document.querySelectorAll('[data-deadline]').forEach(function(el){
    el.textContent = (dow === 0 ? 'Commandez avant ce soir' : 'Commandez avant dimanche soir')
      + ' pour une installation la semaine du ' + frDate(weekMon);
  });

  /* annonce rotative */
  var annEl = document.getElementById('annonceMsg');
  if(annEl){
    var msgs = [annEl.dataset.m1, annEl.dataset.m2, annEl.dataset.m3].filter(Boolean);
    var aIdx = 0;
    if(msgs.length > 1) setInterval(function(){
      annEl.classList.add('fade');
      setTimeout(function(){ aIdx = (aIdx + 1) % msgs.length; annEl.textContent = msgs[aIdx]; annEl.classList.remove('fade'); }, 400);
    }, 5200);
  }

  /* sticky + widgets */
  var sticky = document.getElementById('sticky'), wa = document.getElementById('wa');
  var showAt = document.getElementById('dsProduct') ? 260 : 640;
  window.addEventListener('scroll', function(){
    var show = window.scrollY > showAt;
    if(sticky) sticky.classList.toggle('on', show);
    if(wa) wa.classList.toggle('up', show);
    document.querySelectorAll('.rv:not(.in)').forEach(function(el){
      if(el.getBoundingClientRect().top < window.innerHeight){ el.classList.add('in'); }
    });
  }, {passive:true});

  /* reveal */
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } }); }, {threshold:.12});
    document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); }); }

  /* menu mobile */
  var burger = document.getElementById('burger'), mnav = document.getElementById('mnav');
  if(burger && mnav){
    function closeM(){ mnav.classList.remove('open'); burger.setAttribute('aria-expanded','false'); }
    burger.addEventListener('click', function(){ var o = mnav.classList.toggle('open'); burger.setAttribute('aria-expanded', o ? 'true' : 'false'); });
    var mc = document.getElementById('mnavClose');
    if(mc) mc.addEventListener('click', function(e){ e.preventDefault(); closeM(); });
    mnav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeM); });
  }

  /* simulateur paiement */
  var opts = document.querySelectorAll('.pay-opt');
  var pm = document.getElementById('payM'), pd = document.getElementById('payD');
  var pdata = {"1": ["1 380 €", "en une fois · c'est réglé"],
               "4": ["345 €<small> × 4</small>", "un paiement par mois pendant 4 mois · sans frais"]};
  opts.forEach(function(b){ b.addEventListener('click', function(){
    opts.forEach(function(o){ o.setAttribute('aria-pressed','false'); });
    b.setAttribute('aria-pressed','true');
    var v = pdata[b.dataset.n]; if(pm) pm.innerHTML = v[0]; if(pd) pd.textContent = v[1];
  }); });

  /* fiche produit : options -> variante, galerie, sticky contextuelle */
  var fp = document.getElementById('dsProduct');
  if(fp){
    var variants = JSON.parse(document.getElementById('dsVariants').textContent);
    var idInput = fp.querySelector('input[name="id"]');
    var groups = fp.querySelectorAll('[data-option-group]');
    function currentSelection(){
      var sel = [];
      groups.forEach(function(g){ var a = g.querySelector('[aria-pressed="true"]'); sel.push(a ? a.dataset.value : null); });
      return sel;
    }
    function syncVariant(){
      var sel = currentSelection();
      var v = variants.find(function(x){ return x.options.every(function(o, i){ return o === sel[i]; }); });
      if(!v) return;
      idInput.value = v.id;
      if(v.featured_media){
        var main = document.getElementById('fpMain');
        var im = document.querySelector('[data-media-id="' + v.featured_media + '"]');
        if(main && im){ main.style.backgroundImage = 'url(' + im.dataset.src + ')';
          document.querySelectorAll('.fp-thumb').forEach(function(t){ t.setAttribute('aria-current', t.dataset.mediaId == v.featured_media ? 'true' : 'false'); }); }
      }
      var swName = document.getElementById('fpSwName');
      if(swName) swName.textContent = sel[1] || '';
    }
    groups.forEach(function(g){ g.querySelectorAll('button').forEach(function(b){
      b.addEventListener('click', function(){
        g.querySelectorAll('button').forEach(function(o){ o.setAttribute('aria-pressed','false'); });
        b.setAttribute('aria-pressed','true'); syncVariant();
      });
    }); });
    document.querySelectorAll('.fp-thumb').forEach(function(t){ t.addEventListener('click', function(){
      var main = document.getElementById('fpMain');
      main.style.backgroundImage = 'url(' + t.dataset.src + ')';
      document.querySelectorAll('.fp-thumb').forEach(function(x){ x.setAttribute('aria-current','false'); });
      t.setAttribute('aria-current','true');
    }); });
    var ex = document.getElementById('dsExpress');
    if(ex){ ex.addEventListener('click', function(){ document.getElementById('dsReturnTo').value = '/checkout'; }); }
    var st = document.getElementById('stTitle'), sb = document.getElementById('stBtn'), ss = document.getElementById('stSub');
    if(st){ st.textContent = fp.dataset.title + ' · lit coffre complet';
      ss.textContent = '1 380 € matelas inclus · ou 4 × 345 € sans frais';
      sb.textContent = 'Ajouter au panier';
      sb.setAttribute('href', '#');
      sb.addEventListener('click', function(e){
        e.preventDefault();
        var form = fp.querySelector('form[action*="/cart/add"]');
        fetch('/cart/add.js', {method: 'POST', body: new FormData(form)})
          .then(function(r){ if(!r.ok) throw 0; return r.json(); })
          .then(function(){ if(window.dsOpenCart) window.dsOpenCart(); })
          .catch(function(){ window.location.href = '/cart'; });
      }); }
    syncVariant();
  }
})();
/* ---- drawer panier ---- */
(function(){
  var cd = document.getElementById('cd'), ov = document.getElementById('cdOv');
  if(!cd) return;
  function frPrix(cents){
    var e = Math.round(cents / 100);
    return (e >= 1000 ? Math.floor(e / 1000) + '\u00a0' + ('00' + (e % 1000)).slice(-3) : e) + ' €';
  }
  function openCd(){ cd.classList.add('on'); ov.classList.add('on'); cd.setAttribute('aria-hidden','false'); renderCd(); }
  window.dsOpenCart = openCd;
  function closeCd(){ cd.classList.remove('on'); ov.classList.remove('on'); cd.setAttribute('aria-hidden','true'); }
  ov.addEventListener('click', closeCd);
  document.getElementById('cdX').addEventListener('click', closeCd);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeCd(); });

  function renderCd(){
    fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      var box = document.getElementById('cdItems');
      var link = document.getElementById('cartLink');
      if(link) link.textContent = 'Panier' + (cart.item_count > 0 ? ' · ' + cart.item_count : '');
      if(cart.item_count === 0){
        box.innerHTML = '<div class="cd-empty">Votre panier est vide.<br>Votre chambre, elle, peut être terminée sous 15 jours.</div>';
        document.getElementById('cdTot').textContent = '0 €';
        return;
      }
      var html = '';
      cart.items.forEach(function(it, i){
        html += '<div class="cd-it"><img src="' + (it.image || '') + '&width=160" alt="">'
          + '<div class="inf"><b>' + it.product_title.replace('Lit coffre ', '') + '</b>'
          + '<div class="v">' + it.variant_title + '</div>'
          + '<button class="rm" data-line="' + (i + 1) + '">Retirer</button></div>'
          + '<span class="pr">' + frPrix(it.final_line_price) + '</span></div>';
      });
      box.innerHTML = html;
      document.getElementById('cdTot').textContent = frPrix(cart.total_price);
      box.querySelectorAll('.rm').forEach(function(b){
        b.addEventListener('click', function(){
          fetch('/cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({line: parseInt(b.dataset.line, 10), quantity: 0})})
            .then(function(){ renderCd(); });
        });
      });
    });
  }

  var link = document.getElementById('cartLink');
  if(link){ link.addEventListener('click', function(e){ e.preventDefault(); openCd(); }); }
  renderCd();

  document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){
    form.addEventListener('submit', function(e){
      var rt = document.getElementById('dsReturnTo');
      if(rt && rt.value === '/checkout') return; /* paiement express : parcours natif */
      e.preventDefault();
      fetch('/cart/add.js', {method: 'POST', body: new FormData(form)})
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(){ openCd(); })
        .catch(function(){ form.submit(); });
    });
  });
})();
/* ---- exit popup ---- */
(function(){
  var ov = document.getElementById('xpOv');
  if(!ov) return;
  var KEY = 'ds_exit_seen';
  try { if(localStorage.getItem(KEY) && Date.now() - parseInt(localStorage.getItem(KEY), 10) < 6048e5) return; } catch(e){}
  var shown = false;
  function show(){
    if(shown) return; shown = true;
    ov.classList.add('on');
    try { localStorage.setItem(KEY, String(Date.now())); } catch(e){}
  }
  function close(){ ov.classList.remove('on'); }
  document.getElementById('xpX').addEventListener('click', close);
  document.getElementById('xpNo').addEventListener('click', close);
  document.getElementById('xpGo').addEventListener('click', function(){
    var code = this.dataset.code;
    try { navigator.clipboard.writeText(code); } catch(e){}
    document.cookie = 'discount_code=' + code + ';path=/;max-age=1209600';
    fetch('/discount/' + encodeURIComponent(code)).catch(function(){});
    close();
    window.location.href = '/collections/tous-les-lits';
  });
  document.addEventListener('mouseout', function(e){
    if(!e.relatedTarget && e.clientY < 12) show();
  });
  if(window.matchMedia('(max-width: 860px)').matches){ setTimeout(show, 30000); }
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') close(); });
})();